import { render, staticRenderFns } from "./ReportLogins.vue?vue&type=template&id=9ca2fd36&scoped=true&"
import script from "./ReportLogins.vue?vue&type=script&lang=js&"
export * from "./ReportLogins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca2fd36",
  null
  
)

export default component.exports